module.exports = __webpack_public_path__ + "img/multiply-logo.847d47c6.png";